// @store-module
import { Module } from "vuex";
import { authState, initialState } from "./state";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { actions } from "./actions";

const authStore: Module<any, authState> = {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};

export default authStore;
